const COGNITO_IDENTITY = process.env.VUE_APP_COGNITO_IDENTITY;
const IOT_ENDPOINT = process.env.VUE_APP_IOT_ENDPOINT;
const IOT_TOPIC = process.env.VUE_APP_IOT_TOPIC;

import EventEmitter from './EventEmitter';

export default class MQTT extends EventEmitter {
  constructor() {
    super();

    this.AWS = require('aws-sdk');
    this.AWSIoTData = require('aws-iot-device-sdk');
    this.client = null;
    this.cognitoIdentity = null;

    this.init();
  }

  init = () => {
    this.AWS.config.region = 'us-east-1';
    this.AWS.config.credentials = new this.AWS.CognitoIdentityCredentials({
      IdentityPoolId: COGNITO_IDENTITY
    });

    this.registerDevice();
    this.client.on('connect', this.onClientConnect);
    this.client.on('message', this.onMessage);
    this.client.on('error', this.getCredentials);
  }

  registerDevice = () => {
    this.client = this.AWSIoTData.device({
      region: this.AWS.config.region,
      host: IOT_ENDPOINT,
      clientId: `${(Math.floor((Math.random() * 100000) + 1))}`,
      protocol: 'wss',
      maximumReconnectTimeMs: 8000,
      debug: process.env.NODE_ENV !== 'production', // do we care?
      accessKeyId: '',
      secretKey: '',
      sessionToken: ''
    });
  }

  getCredentials = () => {
    this.cognitoIdentity = new this.AWS.CognitoIdentity();
    this.AWS.config.credentials.get((err, data) => {
      if (!err) {
        const params = {
          IdentityId: this.AWS.config.credentials.identityId
        };
        this.cognitoIdentity.getCredentialsForIdentity(params, (err, data) => {
          if (!err) {
            this.client.updateWebSocketCredentials(
              data.Credentials.AccessKeyId,
              data.Credentials.SecretKey,
              data.Credentials.SessionToken
            );
          } else {
            console.error('error retrieving credentials: ' + err)
          }
        })
      } else {
        console.error('error retrieving identity: ' + err)
      }
    });
  }

  onClientConnect = () => {
    this.client.subscribe(IOT_TOPIC);
  }

  onMessage = (topic, payload) => {
    try {
      const data = JSON.parse(payload);
      this.emit('message', data);
    } catch (err) {
      this.emit('error', err);
    }
  }
};
